import React, { useState,useEffect } from "react";
//import { useDispatch, useSelector } from "react-redux"; // remove
//import {
//setTitle,
//setDescription,
//setSurveyId,
//} from "../../../../../features/survey"; //remove
import { useEyeconxStore } from "../../../../store/eyeconxStore";
import surveyService from "../../../../services/survey.service";

import { Link } from "react-router-dom";
const ScTopbar = () => {
 /* const survey = useEyeconxStore((state) =>(
    {
      id :state.id,
      title: state.title,
     
      description:state.description,
      pageOption: state.pageOption,
      completeMessage: state.completeMessage,
      redirectUrl: state.redirectUrl,
      titlePosition: state.titlePosition,
      logoPosition: state.logoPosition,
      hasLogo: state.hasLogo,
      logoUrl: state.logUrl,
      data: state.data,
    }
  )
  );*/
  const {survey,setTitle,setDescription,setId} = useEyeconxStore()
 // );
 // const setTitle = useEyeconxStore((state) => state.setTitle);
 // const setDescription = useEyeconxStore(
  //  (state) => state.setDescription
  //);
 // const setSurveyId = useEyeconxStore((state) => state.setId);
  const adminClinicId = useEyeconxStore((state) => state.user.clinicId);
  const title = survey.title;
  const description = survey.description;

  const [isTitleEdit, setIsTitleEdit] = useState(false);
  const [isDescEdit, setIsDescEdit] = useState(false);

  

  const handleSave = () => {
    
    if (survey.title && survey.data.length !== 0) {
      console.log("Save the Survey");
      console.log(survey);
      //Create new survey if there is no Id else update the survey
      if (!survey.id) {
        console.log("create New SUrvey");
        surveyService
          .saveEcxSurvey(adminClinicId, survey)
          .then((res) => {
            console.log("Response on create");
            console.log(res.data);
            setId(res.data.id)
            //setSurveyId(res.data.id);
          })
          .catch((err) => {
            console.log(err);
          });
      } else {
        console.log("update the survey");
        surveyService
          .updateEcxSurvey(adminClinicId, survey.id, survey)
          .then((res) => {
            console.log(res.data);
          })
          .catch((err) => {
            console.log(err);
          });
      }
    }
  };

  const handleTitleChange = (e)=>{
    setTitle(e.target.value)
  }
  return (
    <>
      <div className="col-md-6 mb-4 mt-2">
        <div className="d-flex flex-column">
          {isTitleEdit ? (
            <input
              className="form-control"
              type="text"
              placeholder={title}
              onBlur={() => setIsTitleEdit(!isTitleEdit)}
              onChange={handleTitleChange}
            />
          ) : (
            <div onClick={() => setIsTitleEdit(!isTitleEdit)}>
              {" "}
              <h2 className="display-4">{title}</h2>
            </div>
          )}

          {isDescEdit ? (
            <input
              className="form-control"
              type="text"
              placeholder={description}
              onBlur={() => setIsDescEdit(!isDescEdit)}
              onChange={(e) => setDescription(e.target.value)}
            />
          ) : (
            <div onClick={() => setIsDescEdit(!isDescEdit)}>
              {" "}
              <p className="text-dark">{description}</p>{" "}
            </div>
          )}
        </div>
      </div>
      <div className="col-md-6 d-flex justify-content-end align-items-center">
        <Link
          to="../../survey-preview"
          target="_blank"
          className="btn btn-primary me-2"
        >
          <span className="bi bi-list-ul"></span> Preview
        </Link>
        <button type="button" className="btn btn-info" onClick={handleSave}>
          <span className="bi bi-check2-square"></span> Save
        </button>
      </div>
    </>
  );
};

export default ScTopbar;
